// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loader-message-combo {\n  top: 0;\n}", "",{"version":3,"sources":["webpack://./src/app/components/sale/cart/combo/combo-product-hotels/combo-product-hotels.component.scss"],"names":[],"mappings":"AACA;EACI,MAAA;AAAJ","sourcesContent":["\r\n.loader-message-combo{\r\n    top: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
